import FullPageScroller from './full-page-scroller.js'
import * as shareURL from './share.js'

const slider = document.querySelector('.slides')
const slides = document.querySelectorAll('.slide')
const scroller = new FullPageScroller(slider, 1, slides.length)

document.querySelector('#next').addEventListener('click', () => {
  scroller.scroll(1)
})

document.querySelector('#prev').addEventListener('click', () => {
  scroller.scroll(-1)
})

Array.from(document.querySelectorAll('.nav-track > div')).forEach(el => {
  el.addEventListener('click', e => {
    const slide = Number(e.target.dataset.slide)
    scroller.scrollTo(slide)
  })
})

function delayAnimation(ms = 500) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}

function animateElements(id, stagger = 250) {
  const els = document.querySelectorAll(`${id} .transition`)
  for(let i = 0; i < els.length; i++) {
    setTimeout(() => {
      const el = els[i]
      const transition = Array.from(el.classList).find(c => c.startsWith('transition-'))
      el.classList.remove(transition)
    }, stagger * i)
  }
}
const shareButton = document.getElementById('share')
const shareModal = document.getElementById('share-modal')
const shareModalScrim = document.getElementById('share-modal-scrim')
const shareModalInner = document.getElementById('share-modal-inner')
const shareCloseButton = document.getElementById('close-share-modal')

function openShareModal(e) {
  e.preventDefault()
  shareModal.classList.remove('share-modal--closed')
  animateElements('#share-modal')
}
async function closeShareModal(e) {
  e.preventDefault()
  shareModalInner.classList.add('transition-zoom-in')
  await delayAnimation(150)
  shareModalScrim.classList.add('transition-fade-in')
  await delayAnimation(300)
  shareModal.classList.add('share-modal--closed')
}

shareButton.addEventListener('click', openShareModal)
shareModalScrim.addEventListener('click', closeShareModal)
shareCloseButton.addEventListener('click', closeShareModal)

const fbButtons = document.querySelectorAll('.facebook')
const twButtons = document.querySelectorAll('.twitter')
const waButtons = document.querySelectorAll('.whatsapp')

function updateShareURLs(id) {
  for(let i = 0; i < fbButtons.length; i++) {
    fbButtons[i].href = shareURL.setFacebookURL(id)
  }
  for(let i = 0; i < twButtons.length; i++) {
    twButtons[i].href = shareURL.setTwitterURL(id)
  }
  for(let i = 0; i < waButtons.length; i++) {
    waButtons[i].href = shareURL.setWhatsAppURL(id)
  }
}

document.addEventListener('slide-change', async () => {
  const slideTrack = Array.from(document.querySelectorAll('[data-slide]'))
  const currentSlide = document.querySelector(`[data-slide="${scroller.currentPage}"]`)
  const pageTracker = document.querySelector('#page-tracker')
  
  slideTrack.forEach(el => el.classList.remove('current-slide'))
  currentSlide.classList.add('current-slide')
  
  pageTracker.innerHTML = `${scroller.currentPage} / ${scroller.totalPages}`
  document.documentElement.style.setProperty('--nav-accent', 'var(--white)')

  localStorage.setItem('current-slide', scroller.currentPage)

  updateShareURLs(scroller.currentPage)

  switch (scroller.currentPage) {
    case 1:
      document.documentElement.style.setProperty('--nav-background', 'var(--white)')
      document.documentElement.style.setProperty('--nav-accent', 'var(--blue)')
      animateElements('#slide1')
      break
    case 2:
      document.documentElement.style.setProperty('--nav-background', 'var(--dark-purple)')
      await delayAnimation()
      animateElements('#slide2')
      break
    case 3:
      document.documentElement.style.setProperty('--nav-background', 'var(--orange)')
      await delayAnimation()
      animateElements('#slide3')
      break
    case 4:
      document.documentElement.style.setProperty('--nav-background', 'var(--dark-purple)')
      await delayAnimation()
      animateElements('#slide3b')
      break
    case 5:
      await delayAnimation()
      animateElements('#slide4', 50)
      document.documentElement.style.setProperty('--nav-background', 'var(--white)')
      document.documentElement.style.setProperty('--nav-accent', 'var(--blue)')
      break
    case 6:
      await delayAnimation()
      animateElements('#slide5')
      document.documentElement.style.setProperty('--nav-background', 'var(--white)')
      document.documentElement.style.setProperty('--nav-accent', 'var(--blue)')
      break
    case 7:
      await delayAnimation()
      animateElements('#slide6')
      document.documentElement.style.setProperty('--nav-background', 'var(--dark-blue)')
      break
    case 8:
      await delayAnimation()
      animateElements('#slide7')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    case 9:
      await delayAnimation()
      animateElements('#slide8')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    case 10:
      await delayAnimation()
      animateElements('#slide9')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    case 11:
      await delayAnimation()
      animateElements('#slide10')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    case 12:
      await delayAnimation()
      animateElements('#slide11')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    case 13:
      await delayAnimation()
      animateElements('#slide12')
      document.documentElement.style.setProperty('--nav-background', 'var(--blue)')
      break
    default: 
      document.documentElement.style.setProperty('--nav-background', 'var(--white)')
      document.documentElement.style.setProperty('--nav-accent', 'var(--blue)')
      break
  }
})

scroller.scrollTo(Number(localStorage.getItem('current-slide')) || 1, 'auto')
//document.dispatchEvent(new CustomEvent('slide-change'))
